const ACTION_SCOPE = '[Moderator]';
export class SetModeratorSearch {
    static readonly type = `${ACTION_SCOPE} Set Search Query`;
    constructor(public query: string) {}
}
export class ModeratorAction {
  static readonly type = `${ACTION_SCOPE} Add item`;
  constructor(public payload: string) { }
}

export class GetModerators {
  static readonly type = `${ACTION_SCOPE} Get Moderator`;
}

export class AddModerator {
  static readonly type = `${ACTION_SCOPE} Add Moderator`;
  constructor(public payload: any) { }
}

export class UpdateModerator {
  static readonly type = `${ACTION_SCOPE} Update Moderator`;
  constructor(public payload: any) { }
}


export class DeleteModerator {
  static readonly type = `${ACTION_SCOPE} Delete Moderator`;
  constructor(public payload: any) { }
}
